<template>
  <button :id="id" :ref="reference" v-shortkey.once="shortcutKeySequence" @shortkey="hotkeyActionHandler(reference)"
    :title="tooltip" :class="['button-6', getTypeClassButton]" :disabled="disabled" @click="$emit('click')">
    <font-awesome-icon v-if="icon" :icon="icon" class="button-icon" />
    <span v-else>{{ value }}</span>
  </button>
</template>

<script>
export default {
  name: "fvlButton",
  props: {
    id: {
      type: String,
      required: true,
    },
    reference: {
      type: String,
    },
    shortcutKeySequence: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
    },
    value: {
      type: String,
      default: "",
    },
    tooltip: {
      type: String,
    },
    buttonType: {
      type: String,
    },
  },
  computed: {
    getTypeClassButton() {
      return this.buttonType || "regular";
    },
  },
  methods: {
    hotkeyActionHandler(button) {
      this.$refs[button].click();
    },
  },
};
</script>

<style scoped>
button {
  width: 100%;
  height: 100%;
}

.button-6 {
  align-items: center;
  background-color: #cccccc;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
  box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
  box-sizing: border-box;
  color: black;
  cursor: pointer;
  font-family: Nunito, Arial, Helvetica, sans-serif;
  font-size: min(24px, 2.5vw);
  justify-content: center;
  line-height: min(24px, 2.5vw);
  min-height: 3rem;
  padding: calc(min(0.875rem, 1.25vw) - 1px) calc(min(1.5rem, 2.75vw) - 1px);
  position: relative;
  text-decoration: none;
  transition: all 250ms;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: baseline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: max-content;
}

.button-6:hover:not([disabled]),
.button-6:focus:not([disabled]) {
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
  color: rgba(0, 0, 0, 0.65);
}

.button-6:hover:not([disabled]) {
  transform: translateY(-1px);
}

.button-6:active {
  background-color: #f0f0f1;
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
  color: rgba(0, 0, 0, 0.65);
  transform: translateY(0);
}

.button-6:disabled {
  background-color: #eeeeee;
  color: #888888;
}

.button-6:not([disabled]).regular .button-icon {
  color: #474747;
}

/*Custom styles for buttons of different types */

button:not([disabled]).correct-button-stakes {
  background-color: #befcc6 !important;
  color: green !important;
}

button:not([disabled]).wrong-button-stakes {
  background-color: lightsalmon !important;
  color: #7e192c !important;
}

button:not([disabled]).correct-button-mimir {
  background-color: #cccccc !important;
  color: #349d34 !important;
}

button:not([disabled]).wrong-button-mimir {
  background-color: #cccccc !important;
  color: #bb5151 !important;
}

button:hover:not([disabled]).correct-button-mimir {
  color: #40c440 !important;
}

button:hover:not([disabled]).wrong-button-mimir {
  color: #dd3f3f !important;
}

button.staked {
  background-color: yellow;
}
</style>